import type { Registry as Services } from '@ember/service';

export interface AccessFlags {
  features: string[];
  hasParity: boolean;
  hasParityAnalyticsStaff: boolean;
  hasRanking: boolean;
  hasRates: boolean;
}

function collectFeaturesAcrossSubscriptions(
  navigation: Services['navigation'],
): string[] {
  const features = new Set<string>();

  for (const subscriptionFeatures of navigation.subscriptionToFeatures.values()) {
    for (const feature of subscriptionFeatures) {
      features.add(feature);
    }
  }

  return Array.from(features);
}

export default function createAccessFlags(
  access: Services['access'],
  navigation: Services['navigation'],
): AccessFlags {
  if (!navigation.hasUnifiedHotelView) {
    return {
      features: Array.from(access.featureFlags),
      hasParity: access.hasParity,
      hasParityAnalyticsStaff: access.hasParityAnalyticsStaff,
      hasRanking: access.hasRanking,
      hasRates: access.hasRates,
    };
  }

  const features = collectFeaturesAcrossSubscriptions(navigation);

  // Mirrors TabService: under unified hotel view rates, parity and ranking
  // answer from every subscription and drop the per-subscription OTA check.
  // Staff parity analytics keeps answering from the current subscription.
  return {
    features,
    hasParity: features.includes('app.parity'),
    hasParityAnalyticsStaff: access.hasParityAnalyticsStaff,
    hasRanking: features.includes('app.ranking'),
    hasRates: features.includes('app.rates'),
  };
}
